import { BuilderCostingActionType } from './enums';
import { BuilderCostingAction, BuilderCostingState } from './interfaces';

export const initialState: BuilderCostingState = {
	isFCCostingLoading: false,
	isFCCostingErrored: null,
	fcCostingList: [],

	isFCMaterialCostingLoading: false,
	isFCMaterialCostingErrored: null,
	fcMaterialCostingList: [],

	isFCLumenCostingLoading: false,
	isFCLumenCostingErrored: null,
	fcLumenCostingList: [],

	cabinetMaterials: {},
	cabinetMaterialsLoading: false,
	cabinetMaterialsError: null,

	wallPanelMaterials: {},
	wallPanelMaterialsLoading: false,
	wallPanelMaterialsError: null,

	counterTopMaterials: [],
	counterTopMaterialsLoading: false,
	counterTopMaterialsError: null,

	wallTiles: [],
	wallTilesLoading: false,
	wallTilesError: null,

	lightingMaterials: [],
	lightingMaterialsLoading: false,
	lightingMaterialsError: null,
	driverMaterials: [],
	driverMaterialsLoading: false,
	driverMaterialsError: null,

	electricalModules: [],
	electricalModulesLoading: false,
	electricalModulesError: null,

	electricalMaterials: {},
	electricalMaterialsLoading: false,
	electricalMaterialsError: null,

	paintMaterials: [],
	paintMaterialsLoading: false,
	paintMaterialsError: null,

	mouldingTypes: [],
	mouldingTypesLoading: false,
	mouldingTypesError: null,

	mouldingPatterns: [],
	mouldingPatternsLoading: false,
	mouldingPatternsError: null,

	sfbMaterials: [],
	sfbMaterialsLoading: false,
	sfbMaterialsError: null,

	curtainMaterials: { fabrics: [], accessories: [] },
	curtainMaterialsLoading: false,
	curtainMaterialsError: null,

	builderChargeConfigs: [],
	builderChargeConfigsLoading: false,
	builderChargeConfigsError: null
};

export default (state = initialState, { type, payload }: BuilderCostingAction): BuilderCostingState => {
	switch (type) {
		case BuilderCostingActionType.FETCH_FC_COSTING: {
			return {
				...state,
				isFCCostingLoading: true
			};
		}

		case BuilderCostingActionType.STORE_FC_COSTING: {
			return {
				...state,
				isFCCostingLoading: false,
				fcCostingList: payload.data
			};
		}

		case BuilderCostingActionType.FETCH_FC_MATERIAL_COSTING: {
			return {
				...state,
				isFCMaterialCostingLoading: true
			};
		}

		case BuilderCostingActionType.STORE_FC_MATERIAL_COSTING: {
			return {
				...state,
				isFCMaterialCostingLoading: false,
				fcMaterialCostingList: payload.data
			};
		}

		case BuilderCostingActionType.FETCH_FC_LUMEN_COSTING: {
			return {
				...state,
				isFCLumenCostingLoading: true
			};
		}

		case BuilderCostingActionType.STORE_FC_LUMEN_COSTING: {
			return {
				...state,
				isFCLumenCostingLoading: false,
				fcLumenCostingList: payload.data
			};
		}

		case BuilderCostingActionType.FETCH_CABINET_MATERIALS: {
			return {
				...state,
				cabinetMaterialsLoading: true,
				cabinetMaterialsError: null
			};
		}

		case BuilderCostingActionType.STORE_CABINET_MATERIALS: {
			return {
				...state,
				cabinetMaterials: {
					...state.cabinetMaterials,
					[payload.type]: payload.data
				},
				cabinetMaterialsLoading: false,
				cabinetMaterialsError: null
			};
		}

		case BuilderCostingActionType.ERROR_CABINET_MATERIALS:
			return { ...state, cabinetMaterialsLoading: false, cabinetMaterialsError: payload.error };

		case BuilderCostingActionType.FETCH_WALL_PANEL_MATERIALS: {
			return {
				...state,
				wallPanelMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_WALL_PANEL_MATERIALS: {
			return {
				...state,
				wallPanelMaterials: {
					...state.wallPanelMaterials,
					[payload.type]: payload.data
				},
				wallPanelMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.STORE_COUNTER_TOP_MATERIALS: {
			return {
				...state,
				counterTopMaterials: payload,
				counterTopMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_WALL_TILES: {
			return {
				...state,
				wallTilesLoading: true
			};
		}

		case BuilderCostingActionType.STORE_WALL_TILES: {
			return {
				...state,
				wallTiles: payload,
				wallTilesLoading: false
			};
		}

		case BuilderCostingActionType.ERROR_WALL_TILES: {
			return {
				...state,
				wallTilesLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_LIGHTS_MATERIALS: {
			return {
				...state,
				lightingMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_LIGHTS_MATERIALS: {
			return {
				...state,
				lightingMaterials: payload,
				lightingMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_DRIVER_MATERIALS: {
			return {
				...state,
				driverMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_DRIVER_MATERIALS: {
			return {
				...state,
				driverMaterials: payload,
				driverMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_ELECTRICAL_MODULES: {
			return {
				...state,
				electricalModulesLoading: true
			};
		}

		case BuilderCostingActionType.STORE_ELECTRICAL_MODULES: {
			return {
				...state,
				electricalModules: payload,
				electricalModulesLoading: false
			};
		}

		case BuilderCostingActionType.EDIT_ELECTRICAL_MODULES: {
			return {
				...state,
				electricalModules: state.electricalModules.map(module =>
					module.id === payload.id ? { ...module, ...payload.data } : module
				)
			};
		}

		case BuilderCostingActionType.FETCH_ELECTRICAL_MATERIALS: {
			return {
				...state,
				electricalMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_ELECTRICAL_MATERIALS: {
			return {
				...state,
				electricalMaterials: {
					...state.electricalMaterials,
					[payload.type]: payload.data
				},
				electricalMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_PAINT_MATERIALS: {
			return {
				...state,
				paintMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_PAINT_MATERIALS: {
			return {
				...state,
				paintMaterials: payload,
				paintMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_MOULDING_TYPES: {
			return {
				...state,
				mouldingTypesLoading: true
			};
		}

		case BuilderCostingActionType.STORE_MOULDING_TYPES: {
			return {
				...state,
				mouldingTypes: payload,
				mouldingTypesLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_MOULDING_PATTERNS: {
			return {
				...state,
				mouldingPatternsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_MOULDING_PATTERNS: {
			return {
				...state,
				mouldingPatterns: payload,
				mouldingPatternsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_SFB_MATERIALS: {
			return {
				...state,
				sfbMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_SFB_MATERIALS: {
			return {
				...state,
				sfbMaterials: payload,
				sfbMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_CURTAIN_MATERIALS: {
			return {
				...state,
				curtainMaterialsLoading: true
			};
		}

		case BuilderCostingActionType.STORE_CURTAIN_MATERIALS: {
			return {
				...state,
				curtainMaterials: payload,
				curtainMaterialsLoading: false
			};
		}

		case BuilderCostingActionType.FETCH_BUILDER_CHARGE_CONFIGS: {
			return {
				...state,
				builderChargeConfigsLoading: true,
				builderChargeConfigsError: null
			};
		}

		case BuilderCostingActionType.STORE_BUILDER_CHARGE_CONFIGS: {
			return {
				...state,
				builderChargeConfigs: (payload ?? []) as Array<Record<string, any>>,
				builderChargeConfigsLoading: false
			};
		}

		default: {
			return state;
		}
	}
};
